<script setup>
import EpisodeListItem from '@/Components/New/Courses/EpisodeListItem.vue'
import { useProgressStore } from '@/Stores/progress'

const progressStore = useProgressStore()

defineProps({
    course: Object,
    chapters: Array,
    episodes: Array,
    currentEpisode: Object,
    identifier: String
})
</script>

<template>
<div v-if="episodes.length" class="lg:max-h-[580px] overflow-y-scroll py-6 pt-0 space-y-6 z-[2] after:w-full after:absolute after:h-12 after:bottom-0 after:bg-gradient-to-t after:from-[rgba(20,22,57,1)]" :id="identifier">
    <div v-if="chapters.length" v-for="(chapter, index) in chapters" :key="chapter.id" class="flex flex-col">
        <div class="md:sticky top-0 h-14 bg-[rgba(20,22,57,1)] z-[1] px-8">
            <div class="relative bg-gradient-to-r from-[rgba(134,133,201,1)] to-[rgba(203,202,255,1)] text-transparent bg-clip-text font-medium pl-4 before:absolute before:-bottom-[10px] before:left-[9px] before:h-[2px] before:bg-gradient-to-r before:from-[rgba(147,132,241,0.3)] before:to-[rgba(147,132,241,0)] before:w-full after:absolute after:w-[8px] after:h-[8px] after:bg-[rgba(147,132,241,0.3)] after:-left-0 after:-bottom-[13px] after:rotate-45 text-sm md:text-base">
                <div class="truncate text-ellipsis">{{ (index + 1).toString().length === 1 ? `0${index + 1}` : `${index + 1}` }}. {{ chapter.title }}</div>
            </div>
        </div>

        <div class="space-y-2 px-4">
            <EpisodeListItem
                v-for="episode in chapter.parts"
                :key="episode.id"
                :episode="episode"
                :course="course"
                :progress="progressStore.percentageProgressForEpisode(episode.id)"
                :selected="currentEpisode?.id === episode.id"
                :identifier="identifier"
            />
        </div>
    </div>
    <div v-else>
        <div class="space-y-2 px-4">
            <EpisodeListItem
                v-for="episode in episodes"
                :key="episode.id"
                :episode="episode"
                :course="course"
                :progress="progressStore.percentageProgressForEpisode(episode.id)"
                :selected="currentEpisode?.id === episode.id"
                :identifier="identifier"
            />
        </div>
    </div>
</div>
</template>
